export const GET_CAR_MAKE_SUCCESS = 'GET_CAR_MAKE_SUCCESS';
export const SHOW_CAR_MAKE_MODAL = 'SHOW_CAR_MAKE_MODAL';
export const HIDE_CAR_MAKE_MODAL = 'HIDE_CAR_MAKE_MODAL';
export const FETCH_MAKES_SUCCESS = 'FETCH_MAKES_SUCCESS';
export const CLEAN_MAKE_STORE = 'CLEAN_MAKE_STORE';



// WEBPACK FOOTER //
// ./src/actionTypes/make.js